module.exports = __webpack_public_path__ + "img/admin-bg-login.c27331c0.jpg";